import { sendMatomoEvent } from "../../utils";

export const trackInfoBoxAccordionExpand = (target: string) => {
  sendMatomoEvent({
    event: "Show Page Intro Block Expand",
    clickTarget: target,
  });
};
